var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input-number',{staticClass:"g-font-input-number",attrs:{"controls-position":"right","controls":_vm.controls,"size":"small","min":_vm.min,"max":_vm.max},model:{value:(_vm.num),callback:function ($$v) {_vm.num=$$v},expression:"num"}})
}
var staticRenderFns = []

export { render, staticRenderFns }